export default __webpack_public_path__ + "static/media/Status.ab2d7b0a.svg";